import React from "react";
import { Box, Typography, Link } from "@mui/material";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        textAlign: "center",
        borderTop: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} MiApp · Hecho con{" "}
        <Link href="https://mui.com" target="_blank" rel="noopener" underline="hover">
          MUI 7
        </Link>{" "}
        +{" "}
        <Link href="https://react.dev" target="_blank" rel="noopener" underline="hover">
          React 18
        </Link>
      </Typography>
    </Box>
  );
}
